import { ReactComponent as CancelCogs } from './cancel-cogs.svg';
import { ReactComponent as EventNote } from './event-note.svg';
import { ReactComponent as HalfStar } from './half-star.svg';
import { ReactComponent as SmallSmiles } from './smallSmiles.svg';
import { ReactComponent as SmallSmilesGray } from './smallSmilesGray.svg';
import { ReactComponent as SmallSmilesWhite } from './smallSmilesWhite.svg';
import { ReactComponent as SmilesMiles } from './smiles-miles.svg';
import { ReactComponent as SmilesCoinYellow } from './smiles-coin-yellow.svg';
import { ReactComponent as HalfStars } from './half-stars.svg';
import { ReactComponent as Alert } from './alert.svg';
import { ReactComponent as Bed } from './bed.svg';

export default {
  bed: Bed,
  'cancel-cogs': CancelCogs,
  'event-note': EventNote,
  'half-star': HalfStar,
  'smiles-miles': SmilesMiles,
  'smiles-small': SmallSmiles,
  'smiles-small-gray': SmallSmilesGray,
  'smiles-small-white': SmallSmilesWhite,
  'smiles-coin-yellow': SmilesCoinYellow,
  'half-stars': HalfStars,
  alert: Alert,
};
